import Vue from "vue";

export default {
  async getTransactions(balanceId, date, take, skip, filterDepositWithdraw, filterBonus, gameCategory) {
    let response = await Vue.http.post("/api/transactions/list", { balanceId, date, take, skip, filterDepositWithdraw, filterBonus, gameCategory });
    return response.data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/transaction.service.js